/** @jsxImportSource theme-ui */
import classNames from 'classnames';

import { sxMixinActiveHover, sxtheme, valignHackTop } from 'utils/cssHelpers';

import { BdIcon } from '../BdIcon';
import { IClickable } from '../common-props';
import { FlexGroup } from '../FlexGroup';
import { Typography } from '../Typography';

type BdCardFooterLinkProps = IClickable & {
  label: string;
  isSelected: boolean;
  testId?: string;
};

export const BdCardFooterLink: React.FC<BdCardFooterLinkProps> = ({
  label,
  onClick,
  isSelected,
  testId,
}) => (
  <div
    data-testid={testId ?? 'footer-onclick'}
    onClick={!isSelected ? onClick : undefined}
    className={classNames({ active: isSelected })}
    sx={{
      px: 3,
      py: 2,
      m: '-1px',
      cursor: 'pointer',
      bg: sxtheme(t => t.colors.deepSea10),
      border: sxtheme(t => `1px solid ${t.colors.stone20}`),
      borderTop: sxtheme(t => `1px solid ${t.colors.deepSea30}`),
      borderBottomLeftRadius: '2px',
      borderBottomRightRadius: '2px',
      ...sxMixinActiveHover(),
      '&.active': {
        border: sxtheme(t => `1px solid ${t.colors.seafoam50}`),
        bg: sxtheme(t => t.colors.seafoam20),
      },
    }}
  >
    <FlexGroup
      suffix={<BdIcon name="icon-chevron-right" color="sea100" bold sx={valignHackTop('2px')} />}
    >
      <Typography variant="button" color="sea90">
        {label}
      </Typography>
    </FlexGroup>
  </div>
);
